/**
 * De BILT- en REF-score van de tekst die de leerkracht bekijkt (het voorbeeld
 * van een tekst of een les; de server rekent ze uit, services/tekstanalyse.py).
 *
 * BILT, technisch lezen: met de band van het niveau, en of de tekst erbinnen
 * valt. REF, begrijpend lezen: het referentieniveau dat de formule geeft. Bij
 * de 2F-niveaus (M8/2F, Plus/2F, 2F) stuurt de app daar ook op bij; bij de
 * lagere niveaus is het alleen ter informatie (zie services/niveaus.py waarom).
 * Zinnen (stap 19c): de gemiddelde zinslengte in woorden, met het doel bij
 * niveau en teksttype en de band van 2 woorden eromheen.
 *
 * Twee decimalen, zoals de server vergelijkt; een band is "64 tot 66": de
 * ondergrens hoort erbij, de bovengrens niet (niveaus.binnen).
 */
import React from 'react';

const getal = (x) => (typeof x === 'number' ? x.toFixed(2).replace('.', ',') : '-');
const tal = (x) => (x == null ? '' : String(x).replace('.', ','));
const eenDecimaal = (x) => (typeof x === 'number' ? x.toFixed(1).replace('.', ',') : '-');
const band = (b) => (b.min != null && b.max != null ? `${tal(b.min)} tot ${tal(b.max)}` : b.min != null ? `${tal(b.min)} of meer` : `onder ${tal(b.max)}`);

export function TekstMaten({ maten, niveau }) {
  if (!maten || typeof maten.bilt !== 'number') return null;
  const buiten = { color: 'var(--waarschuw-tekst)', fontWeight: 600 };
  return (
    <small style={{ display: 'block', marginTop: 4 }} data-testid="tekstmaten">
      BILT <strong style={maten.bilt_binnen === false ? buiten : undefined}>{getal(maten.bilt)}</strong>
      {maten.bilt_band && <span className="text-muted"> ({niveau}: {band(maten.bilt_band)}{maten.bilt_binnen === false ? ', buiten de band' : ''})</span>}
      {' | '}REF <strong style={maten.ref_stuurt_bij && maten.ref_binnen === false ? buiten : undefined}>{getal(maten.ref)}</strong>
      <span className="text-muted">
        {' '}= {maten.ref_niveau}
        {maten.ref_stuurt_bij
          ? ` (doel ${maten.ref_doel}: ${band(maten.ref_band)}${maten.ref_binnen === false ? ', buiten de grenzen' : ''})`
          : ' (ter informatie)'}
      </span>
      {typeof maten.zinslengte === 'number' && (
        <>
          {' | '}zinnen <strong style={maten.zinslengte_binnen === false ? buiten : undefined}>{eenDecimaal(maten.zinslengte)}</strong>
          <span className="text-muted">
            {' '}woorden{maten.zinslengte_band
              ? ` (doel ${tal(maten.zinslengte_band.doel)}: ${band(maten.zinslengte_band)}${maten.zinslengte_binnen === false ? ', buiten de band' : ''})`
              : ''}
          </span>
        </>
      )}
    </small>
  );
}
